import styled from 'styled-components';

export const HistoryWrapper = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 100%;
    background: #964F39;
    z-index: 5;
    overflow: hidden;
    border-top: solid 27px #FCC089;
    padding: 80px 0;


    `
    export const SchaduleContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    opacity: 0;
    transform: translateY(100px);    
`
export const TitleHistory = styled.h2`
    display: flex;
    font-size: 32px;
    margin-bottom: 20px;
    text-transform: uppercase;
    text-align: center;
    color: white;
    align-self: center;
    justify-content: center;
`

export const TitleSeparador = styled.div`
    display: flex;
    width: 15%;
    height: 9px;
    background: white;
    margin-bottom: 40px;
    overflow-y: hidden;

`

export const Wrapper1 = styled.div`
    display: flex;
    align-items: center;
    width: 80%;
    padding: 10px;
    margin-bottom: 40px;
    justify-content: center;

    @media screen and (max-width: 768px) {
        flex-direction: column;
        margin-bottom: 20px;
        width: 90%;
    }
`

export const HistoryImgOne = styled.img`
    width: 40%;
    margin: 0 40px 0 0;
    border-radius: 22px;
    flex-shrink: 0;

    @media screen and (max-width: 768px) {
        width: 65% ;
        margin: 0 0 40px 0;
    }
    @media screen and (max-width: 480px) {

    }
    @media screen and (max-width: 320px) {
        width: 95%;
    }

`
export const HistoryImgTwo = styled.img`
    width: 40%;
    margin: 0 0 0 40px;
    border-radius: 22px;
    flex-shrink: 0;

    @media screen and (max-width: 768px) {
        width: 65%;
        margin: 0 0 40px 0;
    }
    @media screen and (max-width: 480px) {

    }
    @media screen and (max-width: 320px) {
        width: 95%;
    }

`


export const ParagOne = styled.p`
    color: white;
    text-align: justify;
    font-size: 1.8rem;
    max-width: 70%;


    @media screen and (max-width: 1024px) {
        font-size: 1.6rem;
    }

    @media screen and (max-width: 768px) {
        font-size: 1.2rem;
        margin-right: 0;

    }
    @media screen and (max-width: 480px) {
        max-width: 90%;
        }
`


export const ParagTwo = styled.p`
    color: white;
    text-align: center;
    font-size: 3.6rem;
    max-width: 800px;
    margin: 40px 0;
    font-family: Niconne;
    max-width: 60%;

    @media screen and (max-width: 768px) {
        font-size: 2rem;
        max-width: 90%;
        margin: 40px 0;
    }
`

export const ParagThree = styled.p`
    color: white;
    text-align: justify;
    font-size: 1.8rem;
    max-width: 70%;


    @media screen and (max-width: 1024px) {
        font-size: 1.6rem;
    }

    @media screen and (max-width: 768px) {
        font-size: 1.2rem;

        margin-right: 0;

    }
    @media screen and (max-width: 480px) {
        max-width: 90%;
    }
`


export const Wrapper2 = styled.div`
    display: flex;
    align-items: center;
    width: 80%;
    padding: 10px;
    margin-bottom: 40px;
    justify-content: center;

    @media screen and (max-width: 768px) {
        flex-direction: column-reverse;
        margin-bottom: 20px;
        width: 90%;
    }

`

export const Parag2 = styled.p`
    color: white;
    font-size: 32px;
    max-width: 800px;
    text-align: right;

    @media screen and (max-width: 768px) {
        font-size: 20px;
        max-width: 400px;
        text-align: center;
    }
`